import { render, staticRenderFns } from "./BankPaymentBody.vue?vue&type=template&id=df85915c&scoped=true&"
import script from "./BankPaymentBody.vue?vue&type=script&lang=ts&"
export * from "./BankPaymentBody.vue?vue&type=script&lang=ts&"
import style0 from "./BankPaymentBody.vue?vue&type=style&index=0&id=df85915c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df85915c",
  null
  
)

export default component.exports